module.exports = __webpack_public_path__ + "static/media/GF3CGF3B成像模式.5963272a.jpg";